const EmojiWall = ({ emojis }) => {
  return (
    <div className="flex flex-wrap justify-center p-2 w-full gap-1">
      {emojis.map(({ emoji, link }, index) => (
        <a
          key={emoji + index}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-2xl md:text-3xl lg:text-4xl hover:scale-110 transition-transform duration-200 p-1"
        >
          {emoji}
        </a>
      ))}
    </div>
  );
};

export { EmojiWall };
